import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[dev-saved-filter-func]',
    standalone: false
})
export class DeviceSavedFilterFuncDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}